import { AfterViewInit, Component, Input } from '@angular/core';
import tippy from 'tippy.js';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {isCarOne, isNestBank} from '../../../core/utils/utils';

@Component({
  selector: 'app-tooltip-icon',
  templateUrl: './tooltip-icon.component.html',
  styleUrls: ['./tooltip-icon.component.scss']
})
export class TooltipIconComponent implements AfterViewInit {

  @Input() description: string;
  @Input() outlined: boolean;
  @Input() theme: string;

  get icon(): string {
    if (isCarOne()) {
      return this.outlined ? 'info_outline' : 'info';
    }
    if (isNestBank()) {
      return 'help_outline';
    }
    return this.outlined ? 'help_outline' : 'help';
  }

  constructor() { }

  public ngAfterViewInit(): void {
    setTimeout(() => {
      const tippyConfig = {
        duration: 250,
        arrow: true,
        arrowType: 'round'
      };
      if (isNotNullOrUndefined(this.theme)) {
        tippyConfig['theme'] = this.theme;
      }
      tippy('.tooltip', tippyConfig);
    }, 100)
  }
}
